export default {
    permission_actions: {
        MARK_CUSTOMER_AS_VIP: 'Marcar un cliente como VIP',
        VALIDATE_CUSTOMERS: 'Validar clientes',
        DOCUMENT_VALIDATION: 'Validar documentacion',
        BLOCK_INTERVENER_AML: 'Bloquear interviniente por AML',
        MANAGE_PRIVATE_OPERATIONS: 'Tratar operaciones privadas'
    },
    permission_objects: {
        USERS: 'Usuarios',
        PERMISSION_SETS: 'Permission sets',
        GROUPS: 'Grupos',
        INTERVENERS: 'Intervinientes',
        IMPORT: 'Importación',
        ACCOUNTS: 'Cuentas',
        ISSUES: 'Casos',
        OPERATIONS: 'Operaciones',
        DISTRIBUTORS: 'Distribuidores',
        SUBDISTRIBUTORS: 'Subdistribuidores',
        RECONCILIATION: 'Conciliación'
    }
};
